<script>
import { useCreationCarteFidelite } from "./mixin";
import CreationCarteFidForm from "@/containers/compte-client/creation-carte-fid-form";
import Container from "@/components/atoms/container";
import LazyImage from "@/components/atoms/lazy-image";
import GridCol from "@/components/molecules/grid/grid-col";
import GridRow from "@/components/molecules/grid/grid-row";
import StateOverlay from "@/components/molecules/state-overlay";

import customerAccountBgFid from "@/assets/images/customer-account-bg-fid.jpg";
import customerAccountBgFidOld from "@/assets/images/customer-account-bg-fid_old.jpg";

export default {
  components: {
    CreationCarteFidForm,
    GridCol,
    GridRow,
    Container,
    LazyImage,
    StateOverlay
  },
  setup() {
    const {
      error,
      state,
      isEligibleDefis,
      isLoading,
      addCarte,
      createCarte,
      isErrorCarteAssociee
    } = useCreationCarteFidelite();

    return {
      error,
      state,
      isEligibleDefis,
      isLoading,
      addCarte,
      createCarte,
      customerAccountBgFid,
      customerAccountBgFidOld,
      isErrorCarteAssociee
    };
  }
};
</script>

<template>
  <div
    id="content"
    role="main"
  >
    <StateOverlay
      overlay
      :is-loading="isLoading"
    >
      <Container class="u-bgcolor-white">
        <GridRow>
          <GridCol
            cols="3"
            no-gutter
          >
            <LazyImage
              :src="isEligibleDefis ? customerAccountBgFid : customerAccountBgFidOld"
              alt="bandeau de confirmation"
              class="form-inscription-illustration form-inscription-illustration--fid"
            />
          </GridCol>
          <GridCol cols="9">
            <CreationCarteFidForm
              class="u-mt-lg u-mt-none@md u-ml-xlg u-ml-md@lg u-ml-none@md"
              :error="error"
              :state="state"
              :is-eligible-defis="isEligibleDefis"
              :is-error-carte-associee="isErrorCarteAssociee"
              @addCarte="addCarte"
              @createCarte="createCarte"
            />
          </GridCol>
        </GridRow>
      </Container>
    </StateOverlay>
  </div>
</template>

<style lang="scss" scoped>
.form-inscription-illustration,
.form-inscription-illustration :deep(img) {
  position: sticky;
  top: 0;
  height: 100vh;
  -o-object-fit: cover;
  object-fit: cover;
  @include ie() {
    width: 100%;
    height: auto;
  }
}

.form-inscription-illustration--fid,
.form-inscription-illustration--fid :deep(img) {
  height: auto;
  object-fit: contain;
}
</style>
